import MobilityHelper from "../../helpers/MobilityHelper"
import RouteHelper from "../../helpers/RouteHelper"
import { News, PublicLocale } from "../../types"
import ERoute from "../ERoute"
import store from "../store"

export const overviewLink = (locale: PublicLocale) => {
  const { newsCenter: { currentLocale, customDomainEnabled, newsCenter } } = store.getState()

  return RouteHelper.process(ERoute.PATH_ROOT, {
    locale: currentLocale,
    // If custom domain is enabled, we don't need to pass newsCenterId
    ...(customDomainEnabled ? {} : { newsCenterId: newsCenter.slug })
  })
}

export const newsLink = (news: News) => {
  const { newsCenter: { currentLocale, customDomainEnabled, newsCenter } } = store.getState()

  return RouteHelper.process(ERoute.PATH_NEWS, {
    locale: currentLocale,
    id: news.id,
    slug: MobilityHelper.getTranslation(currentLocale, news.translations, 'slug'),
    // If custom domain is enabled, we don't need to pass newsCenterId
    ...(customDomainEnabled ? {} : { newsCenterId: newsCenter.slug })
  })
}